import { API_URL } from '../../config';

export function checkUniquenessOfAgencyName(name){
  return fetch(`${API_URL}/pub/v1/agency/findByName?name=${name}`,{
    method:'GET',
    headers:{
      'Accept':'application/json',
      'Content-Type':'application/json'
    }
  })
  .then((res) => {
    if(res.status === 404){
      return Promise.resolve({ 
        data:{
          active:false,
          emailVerified:false        
        }
      });
    } else {
      return res.json();
    }
  })
  .then((res) => res.data);
}



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/utils.js